import api from '../api';

export async function sendNSerie(NumSerie) {
  return api.get(`atendimento/send/validacao/${NumSerie}`);
}
